<!-- <app-route-header [title]="pageTitle"></app-route-header> -->
<app-hero-image [src]="heroImageUrl"></app-hero-image>
@if (introContent) {
  <div>
    <p>
      {{introContent}}
    </p>
  </div>
}
@if (contentBlocks) {
  <app-content-block-container [maxBlocks]="MAXBLOCKS" [contentBlocks]="contentBlocks">
  </app-content-block-container>
}